/*eslint-disable*/
import React, { useState } from 'react'
import { Button, Icon } from 'semantic-ui-react'
import cogoToast from "cogo-toast";
import DeleteModal from './deleteModal'

function BillActionButton(props) {
    const [purchaseOrderId, setPurchaseOrderId] = useState('')
    const [openBox, setopenBox] = useState(false)

    let handleDelete = () => {
        console.log("Delete Props", props.data)
        let status = props.data.status
        if (status == "Pending") {
            props.data.deleteBill(props.data.billReferenceNo)
        }
        else {
            cogoToast.info("Bill cannot be edited")
        }
    }

    let handleEdit = (e) => {
        let bill = props.data
        let status = props.data.status
        if (status == "Pending") {
            props.data.getVendorPurchaseOrder(props.data.vendorCode)
            let history = props.agGridReact.props.baseURL.history
            history.push({ pathname: '/view-bill', state: { id: bill.refNo, vendorCode: bill.vendorCode } })
        }
        else {
            cogoToast.info("Bill cannot be edited")
        }
    }


    // let handleOpenHistory = (e) => {
    //     let mainData = props.data
    //     let history = props.agGridReact.props.baseUrl.history
    //     history.push({ pathname: '/jobcard-info', state: { id: mainData.id } })
    // }

    let handleOpenDelete = (e) => {
        let mainData = props.data
        let status = props.data.status
        if (status == "Pending") {
            setopenBox(true)
        }
        else {
            cogoToast.info("Bill cannot be deleted")
        }
    }

    let handleView = (e) => {
        let bill = props.data
        let history = props.agGridReact.props.baseURL.history
        history.push({ pathname: '/view-bill', state: { id: bill.refNo, billId: bill.billId, vendorCode: bill.vendorCode } })

    }

    let handleCloseDelete = () => {
        setopenBox(false)
    }

    let mainData = props.data

    // const updateTyre = props.agGridReact ? props.agGridProps.baseUrl.updateTyre : ''

    return (
        <>
            {/* <Button disabled={ true} onClick={handleOpenHistory} basic size="mini" type="button" icon> <Icon name="history" color="blue" /></Button> */}
            {/* <Button  onClick={handleEdit} basic size="mini" type="button" icon> <Icon name="edit" color="green" /></Button> */}
            <Button  onClick={handleView} basic size="mini" type="button" icon> <Icon name="eye" color="blue" /></Button>
            <Button onClick={handleOpenDelete} basic size="mini" type="button" icon> <Icon name="trash" color="red" /></Button>
            <DeleteModal open={openBox} onClose={handleCloseDelete} handleDelete={handleDelete} isLoading={props.data.isLoading} />
        </>
    )
}

export default BillActionButton
